import { Button, Heading } from '@/components/atoms';
import { preserveEmptyParagraphs } from '@/lib/helpers';
import { cn } from '@/lib/utils';
import toast from 'react-hot-toast';

interface StoreCardProps {
  image: string;
  name: string;
  description: string;
  domain: string;
  className?: string;
  handleClick?: () => void;
}

export const StoreCard = ({
  image,
  name,
  description,
  domain,
  className,
  handleClick,
}: StoreCardProps) => {
  const handleCopyDomain = () => {
    const storeUrl = `https://${domain}.sellyt.shop`;
    navigator.clipboard.writeText(storeUrl);
    toast.success('Store link copied to clipboard!');
  };

  return (
    <div
      className={cn(
        'p-2 rounded-md border border-accent flex flex-col gap-4 transition-colors group bg-white max-w-md',
        className
      )}
    >
      <div className="border border-accent bg-accent/40 rounded-sm flex h-52 items-center justify-center overflow-hidden">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-300 rounded-sm overflow-hidden"
        />
      </div>
      <div className="flex flex-col gap-4 justify-between p-2">
        <div className="flex flex-col gap-1.5">
          <Heading>{name}</Heading>
          <div
            dangerouslySetInnerHTML={{
              __html: preserveEmptyParagraphs(description),
            }}
            className="custom-typography **:wrap-break-word text-sm"
          />
        </div>
        <div className="flex gap-2">
          <Button
            label="Edit store"
            className="rounded-sm flex-1"
            onClick={handleClick}
          />
          <Button
            className="rounded-sm"
            variant="outline"
            onClick={handleCopyDomain}
            label="Copy store link"
          />
        </div>
      </div>
    </div>
  );
};
